export const IS_PROD = import.meta.env.PROD;
export const IS_DEV = import.meta.env.DEV;
export const MODE = import.meta.env.MODE;
